export const settings = {
    base_api: "/api",
    b2c_api: "/api/b2c",
    admin_api: "/api/admin",
    configration_api: "/api/configurations",
    default_locale: "en",
    languages: [
        {
            locale: "en",
            name: "English"
        },
        {
            locale: "no",
            name: "Norsk"
        }
    ],
    claim_types:[
        'customer_service',
        'data_management'
    ]
}
